<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="d-flex justify-end">
                <v-btn :loading="loadingData" text color="primary" @click="loadData">recargar totales</v-btn>
            </v-col>
        </v-row>
        <v-row v-if="loadedData && close">
            <v-col cols="12">
                Fecha: {{ close.created_at }}

                <v-list>
                    <template v-for="(item, key) in close.items">
                        <v-list-item v-if="close" :key="key">
                            <v-list-item-content>
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                <v-list-item-subtitle>Oficinas activas: {{ item.ofi_active }}</v-list-item-subtitle>
                                <v-list-item-subtitle>Rutas activas: {{ item.routes_active }}</v-list-item-subtitle>
                                <v-list-item-subtitle>Multas: {{ item.multas }}</v-list-item-subtitle>                                
                                <v-list-item-subtitle>{{ item.amount.toLocaleString("es-VE") }}USDT</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider :key="`div${key}`" v-if="key != close.items.length - 1" />
                    </template>
                </v-list>
            </v-col>
            <v-col cols="12" class="d-flex justify-end" style="font-size: 1.4em;">
                TOTAL: {{ total.toLocaleString("es-VE") }} USDT
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    mounted() {
        this.loadData();
    },

    data() {
        return {

            close: null,
            loadingData: false,
            loadedData: false,
        }
    },

    computed: {
        total() {
            let result = 0;
            if (this.close) {
                if (this.close.items) {
                    for (let key in this.close.items) {
                        result += this.close.items[key].amount;
                        result += this.close.items[key].multas;
                    }
                    return result;
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
        },
    },

    methods: {
        loadData() {
            this.loadingData = true;
            this.loadedData = false;
            this.close = null;

            setTimeout(() => {
                this.$store.dispatch('findCloseAction').then((res) => {
                    this.close = res
                    this.loadingData = false;
                    this.loadedData = true;
                }).catch(() => {
                    this.loadingData = false;
                    this.loadedData = false;
                })
            }, 500);

        },


    },

}
</script>
